<template>
  <div class="container-fluid p-0" :class="[redBg, secondNav]">
    <div class="container">
      <div class="row py-4">
        <div class="col-6 col-lg-6 col-xl-3" @click="checkBtt(mu2)">
          <div class="nav-thumbnail py-3">
            <router-link :to="{ name: 'GlobalVisibility-MissYouToo' }">
              <img alt="" src="@/assets/initiatives/globalVisibility/menubar_pic01.jpg" />
            </router-link>
          </div>
          <div class="nav-desc" :class="mainTheme">
            {{ $t("gv.mu2.heading") }}
          </div>
        </div>
        <div class="col-6 col-lg-6 col-xl-3" @click="checkBtt(x360)">
          <div class="nav-thumbnail py-3">
            <router-link :to="{ name: 'GlobalVisibility-360' }">
              <img alt="" src="@/assets/initiatives/globalVisibility/menubar_pic02.jpg" />
            </router-link>
          </div>
          <div class="nav-desc" :class="mainTheme">
            {{ $t("gv.360.heading") }}
          </div>
        </div>
        <div class="col-6 col-lg-6 col-xl-3" @click="checkBtt(mega)">
          <div class="nav-thumbnail py-3">
            <router-link :to="{ name: 'GlobalVisibility-Mega' }">
              <img alt="" src="@/assets/initiatives/globalVisibility/menubar_pic03.jpg" />
            </router-link>
          </div>
          <div class="nav-desc" :class="mainTheme">
            {{ $t("gv.mega.heading") }}
          </div>
        </div>
        <div class="col-6 col-lg-6 col-xl-3" @click="checkBtt(ssuper)">
          <div class="nav-thumbnail py-3">
            <router-link :to="{ name: 'GlobalVisibility-Super' }">
              <img alt="" src="@/assets/initiatives/globalVisibility/menubar_pic04.jpg" />
            </router-link>
          </div>
          <div class="nav-desc" :class="mainTheme">
            {{ $t("gv.fans.heading") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GvNav",
  methods: {
    checkBtt(el) {
      if (el === true) {
        // document
        //   .querySelector(".page-header")
        //   .scrollIntoView({ behavior: "smooth", block: "center" });
        document.documentElement.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    },
  },
  props: {
    mainTheme: String,
    redBg: String,
    secondNav: String,
    mu2: Boolean,
    x360: Boolean,
    mega: Boolean,
    ssuper: Boolean,
  },
};
</script>

<style lang="scss" scoped></style>
